import styled, { css } from 'styled-components';

import {
    BACKGROUND_DEEP,
    CONTENT_BASE,
    CONTENT_BACKUP,
    PRIMARY_HOVER,
    SURFACE_BASE,
    TERTIARY_BACKGROUND,
    TERTIARY_BORDER,
} from '@amzn/ring-common-style-library/lib/colors';

import {
    BODY_SMALL_MEDIUM,
    FOOTNOTE_XSMALL_LIGHT,
} from '@amzn/ring-common-style-library/lib/typography';

const cardStates = css<{ disabled?: boolean; }>`
    border: 1px solid ${TERTIARY_BORDER};
    background: ${SURFACE_BASE};

    ${({ disabled }) =>
        !disabled && css`
        cursor: pointer;
        &:hover {
            background: ${BACKGROUND_DEEP};
            border: 1px solid ${PRIMARY_HOVER};
        }

        &:active {
            background: ${TERTIARY_BACKGROUND};
            border: 1px solid ${BACKGROUND_DEEP};
        }
    `}
`;

const ProductCard = styled.div<{ disabled?: boolean; }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    max-width: 298px;
    padding: 8px;
    gap: 8px;

    border-radius: 8px;
    ${cardStates} 
`;

const ProductImage = styled.img`
    height: 80px;
    width: 80px;
    flex-shrink: 0;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-self: stretch;
    justify-content: center;
    align-items: flex-start;

    max-width: 160px;
    gap: 4px;
    flex: 1 0 0;
`;

const Title = styled.div`
    ${BODY_SMALL_MEDIUM};
    color: ${CONTENT_BASE};
`;

const Subtext = styled.div`
    ${FOOTNOTE_XSMALL_LIGHT};
    color: ${CONTENT_BACKUP};
`;

const PriceWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;

    gap: 8px;
`;

const Price = styled.div`
    ${BODY_SMALL_MEDIUM};
    color: ${CONTENT_BASE};
`;

const MarkdownPrice = styled.div`
    ${FOOTNOTE_XSMALL_LIGHT};
    color: ${CONTENT_BACKUP};
    text-decoration: line-through;

    margin-top: 1px;
`;

const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 24px;
    height: 24px;
`;

export default {
    ProductCard,
    ProductImage,
    ContentWrapper,
    Title,
    Subtext,
    PriceWrapper,
    Price,
    MarkdownPrice,
    Icon
}